export default __webpack_public_path__ + "static/media/B0000.891d1b97.png";